import { APP_BASE_HREF } from '@angular/common'
import { CURRENT_ORG_ID } from './current-org-id.provider'

// set the /organization:xxx token as the base path for all urls for convenient routing
export const baseHrefProvider = {
  provide: APP_BASE_HREF,
  deps: [CURRENT_ORG_ID],
  useFactory: (currentOrgId: string) => `/organization:${currentOrgId}`
}
